import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { GenericShipping, ShippingApplyTo, ShippingKeys } from '../../typings'
import messages from './messages'

export function validationShippingVariantSuite<Base>(intl: IntlShape) {
  return create((benefit: GenericShipping<Base>) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(benefit.applyTo !== ShippingApplyTo.selected, () => {
      test(ShippingKeys.selectedMethods, $t(validation.required), () => {
        enforce(
          (benefit as { selectedMethods }).selectedMethods.length
        ).greaterThan(0)
      })
    })
  })
}
